// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_1s3JV","attachments":"index_attachments_3LEd-","attachmentsTitle":"index_attachmentsTitle_1EnVR","attachmentsList":"index_attachmentsList_3-h7K"};